import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
import { tracked } from "@glimmer/tracking";
import { getOwner, setOwner } from "@ember/application";
import { warn } from "@ember/debug";
import EmberObject from "@ember/object";
import { equal } from "@ember/object/computed";
import { Promise } from "rsvp";
import { getOwnerWithFallback } from "discourse-common/lib/get-owner";
let RestModel = (_dec = equal("__state", "new"), _dec2 = equal("__state", "created"), (_class = class RestModel extends EmberObject {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "isSaving", _descriptor, this);
    _initializerDefineProperty(this, "isNew", _descriptor2, this);
    _initializerDefineProperty(this, "isCreated", _descriptor3, this);
  }
  // Overwrite and JSON will be passed through here before `create` and `update`
  static munge(json) {
    return json;
  }
  static create(args) {
    args = args || {};
    args.__munge = this.munge;
    const createArgs = this.munge(args, args.store);

    // Some Discourse code calls `model.create()` directly without going through the
    // store. In that case the owner is not set, and injections will fail. This workaround ensures
    // the owner is always present. Eventually we should use the store for everything to fix this.
    const receivedOwner = getOwner(createArgs);
    if (!receivedOwner || receivedOwner.isDestroyed) {
      setOwner(createArgs, getOwnerWithFallback());
    }
    return super.create(createArgs);
  }
  beforeCreate() {}
  afterCreate() {}
  beforeUpdate() {}
  afterUpdate() {}
  update(props) {
    if (this.isSaving) {
      return Promise.reject();
    }
    props = props || this.updateProperties();
    this.beforeUpdate(props);
    this.set("isSaving", true);
    return this.store.update(this.__type, this.id, props).then(res => {
      const payload = this.__munge(res.payload || res.responseJson);
      if (payload.success === "OK") {
        (false && warn("An update call should return the updated attributes", {
          id: "discourse.rest-model.update-attributes"
        }));
        res = props;
      }
      this.setProperties(payload);
      this.afterUpdate(res);
      res.target = this;
      return res;
    }).finally(() => this.set("isSaving", false));
  }
  _saveNew(props) {
    if (this.isSaving) {
      return Promise.reject();
    }
    props = props || this.createProperties();
    this.beforeCreate(props);
    const adapter = this.store.adapterFor(this.__type);
    this.set("isSaving", true);
    return adapter.createRecord(this.store, this.__type, props).then(res => {
      if (!res) {
        throw new Error("Received no data back from createRecord");
      }

      // We can get a response back without properties, for example
      // when a post is queued.
      if (res.payload) {
        this.setProperties(this.__munge(res.payload));
        this.set("__state", "created");
      }
      this.afterCreate(res);
      res.target = this;
      return res;
    }).finally(() => this.set("isSaving", false));
  }
  createProperties() {
    throw new Error("You must overwrite `createProperties()` before saving a record");
  }
  save(props) {
    return this.isNew ? this._saveNew(props) : this.update(props);
  }
  destroyRecord() {
    return this.store.destroyRecord(this.__type, this);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isSaving", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isNew", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isCreated", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { RestModel as default };